export const languages = {
  en: {
    title: 'Languages',
    items: [
      {
        language: 'Portuguese',
        level: 'Native'
      },
      {
        language: 'English',
        level: 'Fluent'
      },
      {
        language: 'Spanish',
        level: 'Advanced'
      },
      {
        language: 'French',
        level: 'Professional'
      }
    ]
  },
  pt: {
    title: 'Idiomas',
    items: [
      {
        language: 'Português',
        level: 'Nativo'
      },
      {
        language: 'Inglês',
        level: 'Fluente'
      },
      {
        language: 'Espanhol',
        level: 'Avançado'
      },
      {
        language: 'Francês',
        level: 'Profissional'
      }
    ]
  }
};